import React from "react";
export default React.createClass({

    componentDidMount: function() {

      // Tabbing in Radio group start
      $(function(){
        $('.radiobutton').radioTabbable();
      });

      $.fn.radioTabbable = function () {
          var groups = [];

          // group the inputs by name
          $(this).each(function () {
              var el = this;
              var thisGroup = groups[el.name] = (groups[el.name] || []);
              thisGroup.push(el);
          });

          $(this).on('keydown', function (e) {
              setTimeout(function () {
                  var el = e.target;
                  var thisGroup = groups[el.name] = (groups[el.name] || []);
                  var indexOfTarget = thisGroup.indexOf(e.target);

                  if (e.keyCode === 9) {
                      if (indexOfTarget < (thisGroup.length - 1) && !(e.shiftKey)) {
                          thisGroup[indexOfTarget + 1].focus();
                      }
                      else if (indexOfTarget > 0 && e.shiftKey) {
                          thisGroup[indexOfTarget - 1].focus();
                      }
                  }
              });
          });
      };
      // Tabbing in Radio group end
    },

    render: function(){
        let options = this.props.options;
        let inlineRadio = false
        if(this.props.inlineRadio) {
          inlineRadio = true
        }

        let required = ""
        if(this.props.requiredField) {
          required = "required"
        }

        return(
            <div id={this.props.field + "-group"} className="row form-div">
              <div className={this.props.bigLabel ? "col-sm-7" : "col-sm-4"}>
                <label className="group-label">{this.props.label}
                {this.props.requiredField &&
                  <span className="requiredField"> * </span>
                }
                </label>
              </div>

              <div className={this.props.bigLabel ? "col-sm-5" : "col-sm-8"}>
                {this.props.requiredField &&
                  options.map((object, i) =>

                    <span key={"radio-span"+i}>
                    {inlineRadio == true && this.props.requiredField &&
                      <span key={i}>
                        <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} required />
                        <label htmlFor={this.props.field + options[i].value} className="radioLabel">{options[i].label} &nbsp;&nbsp;</label>
                      </span>
                    }
                    {inlineRadio == false && this.props.requiredField &&
                       <p key={i}>
                        <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} required />
                        <label htmlFor={this.props.field + options[i].value} className="radioLabel">
                          {options[i].label}
                          {options[i].hint && <span className="small-font"> ({options[i].hint})</span> }
                        </label>
                      </p>
                    }
                    {inlineRadio == true && !this.props.requiredField &&
                      <span key={i}>
                        <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} />
                        <label htmlFor={this.props.field + options[i].value} className="radioLabel">{options[i].label} &nbsp;&nbsp;</label>
                      </span>
                    }
                    {inlineRadio == false && !this.props.requiredField &&
                      <p key={i}>
                        <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} />
                        <label htmlFor={this.props.field + options[i].value} className="radioLabel">
                          {options[i].label}
                          {options[i].hint && <span className="small-font"> ({options[i].hint})</span> }
                        </label>
                      </p>
                    }
                    </span>
                  )
                }
                {!this.props.requiredField &&
                  options.map((object, i) =>
                  <span key={"radio-span"+i}>
                  {inlineRadio == true &&
                    <span key={i}>
                      <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} />
                      <label htmlFor={this.props.field + options[i].value} className="radioLabel">{options[i].label}</label> &nbsp;&nbsp;
                    </span>
                  }
                  {inlineRadio == false &&
                    <p key={i}>
                      <input type="radio" name={this.props.field} id={this.props.field + options[i].value} className="radiobutton" value={options[i].value} onChange={this.props.change} />
                      <label htmlFor={this.props.field + options[i].value} className="radioLabel">
                        {options[i].label}
                        {options[i].hint && <span className="small-font"> ({options[i].hint})</span> }
                      </label>
                    </p>
                  }
                  </span>
                )}

              </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/js/components/elements/radio-row.jsx